import React, {useEffect, useRef} from 'react';
import AppLayout from "@layouts/app.layout";
import styled from "styled-components";
import HayaatMainSection from "@organisms/property/landing/hayaat/main_section";
import {useWindowSize} from "@helpers/windows.size";
import HayaatVideoSection from "@organisms/property/landing/hayaat/video_section";
import HayaatQuoteSection from "@organisms/property/landing/hayaat/quote_section";
import HayaatGallerySlide from "@organisms/property/landing/hayaat/gallery_slide";
import HayaatFeaturesSection from "@organisms/property/landing/hayaat/features_section";
import HayaatTabsSection from "@organisms/property/landing/hayaat/tabs_section";
import HayaatInvestmentFormSection from "@organisms/property/landing/hayaat/investment_form_section";
import {scrollToRef} from "@helpers/helpers";
import {getDefaultCity} from "../../../components/hooks/cities";
import {getCityById} from "../../../models/district";
import {isEmpty} from "../../../components/helpers/helpers";
import '@assets/scss/swiper/swiper.scss';
import 'react-perfect-scrollbar/dist/css/styles.css';


const YahaatLanding = ({defaultCity}) => {
    const windowSize = useWindowSize();
    const investTopButtonRef = useRef('');
    const investmentFormRef = useRef('');

    const showInvestForm = () => {
        scrollToRef(investmentFormRef)
    };

    useEffect(() => {
        const handleScroll = () => {
            if (window.innerWidth < 992) {
                const formOffsetTop = investmentFormRef.current.offsetTop;
                const windowOffsetTop = (window.scrollY + window.innerHeight) - 26;

                if (windowOffsetTop > formOffsetTop) {
                    investTopButtonRef.current.classList.add('d-none');
                } else {
                    investTopButtonRef.current.classList.remove('d-none');
                }
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    });

    return (
        <AppLayout
            investment={false}
            footer={false}
            pageRobots="index, follow, all"
            pageCanonicalLink="/hayaat"
            pageTitle="برج حیات مشهد"
            pageDescription="در چند قدمی حرم امام رضا (ع)، مالک آپارتمان مبله اما با امکانات اقامت در سطح یک هتل شوید. همچنین با وجود حراست و خانه‌داری هتل، در زمان عدم حضور شما در مشهد، دغدغه‌ای برای امنیت آپارتمان خود و نگهداری از آن نخواهید داشت."
            ogDescription="در چند قدمی حرم امام رضا (ع)، مالک آپارتمان مبله اما با امکانات اقامت در سطح یک هتل شوید. همچنین با وجود حراست و خانه‌داری هتل، در زمان عدم حضور شما در مشهد، دغدغه‌ای برای امنیت آپارتمان خود و نگهداری از آن نخواهید داشت."
        >

            <Container>
                <section>
                    <HayaatMainSection
                        windowSize={windowSize}
                        investTopButtonRef={investTopButtonRef}
                        showInvestForm={showInvestForm}
                        defaultCity={defaultCity}
                    />
                </section>

                <Section>
                    <HayaatVideoSection/>
                </Section>

                <Section>
                    <HayaatQuoteSection
                        windowSize={windowSize}
                    />
                </Section>

                <Section>
                    <HayaatGallerySlide/>
                </Section>

                <Section>
                    <HayaatFeaturesSection/>
                </Section>

                <Section>
                    <HayaatTabsSection/>
                </Section>

                <Section ref={investmentFormRef}>
                    <HayaatInvestmentFormSection/>
                </Section>
            </Container>
        </AppLayout>
    );
};

YahaatLanding.getInitialProps = async (context) => {
    const {req, asPath} = context;
    let defaultCityId = 259;

    if (req && req.cookies && !isEmpty(req.cookies['default_city_id'])) {
        defaultCityId = req.cookies['default_city_id'];
    } else if (process.browser) {
        defaultCityId = getDefaultCity();
    }

    const defaultCity = await getCityById(defaultCityId);

    return {
        defaultCity
    }
};

export default YahaatLanding;

// styles

const Container = styled.div`

`;

const Section = styled.section`
    margin-top: 112px;
    
    @media (max-width: ${props => props.theme.screenSmMax}) {
        margin-top: 56px;
    }
`;
